import React from 'react';
import { Link } from 'react-router-dom';

function StudentsCard({ students }) {
  return (
    <div className='overflow-x-auto'>
      <table className='min-w-full'>
        <thead>
          <tr>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              No.
            </th>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              Image
            </th>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              Name
            </th>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              Class
            </th>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              Library ID
            </th>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              Mobile
            </th>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              Session
            </th>
          </tr>
        </thead>
        <tbody className='bg-white divide-y divide-gray-200'>
          {students.map((student, index) => (
            student.accountType === 'Student' && (
              <tr key={student._id}>
                <td className='px-6 py-4 whitespace-nowrap'>{index +1 }.</td>
                <td className='px-6 py-4 whitespace-nowrap'>
                  <img src={student.image} alt={`Student ${index }`} className='h-10 w-10 rounded-full' />
                </td>
                <td className='px-6 py-4 whitespace-nowrap'>
                  <Link to={`/dashboard/student/${student._id}`} className='text-indigo-600 hover:text-indigo-900'>
                    {student.firstName} {student.lastName}
                  </Link>
                </td>
                <td className='px-6 py-4 whitespace-nowrap'>{student.className}</td>
                <td className='px-6 py-4 whitespace-nowrap'>{student.libraryId}</td>
                <td className='px-6 py-4 whitespace-nowrap'>{student.contactNumber}</td>
                <td className='px-6 py-4 whitespace-nowrap'>{student.session}</td>
              </tr>
            )
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default StudentsCard;
